import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./cta-button.module.css";
export const CtaButton = ({ href , onClick , small , className , children  })=>{
    const classNames = cx(styles.ctaButton, {
        [`${className}`]: className,
        [styles.ctaButtonSmall]: small
    });
    if (href) {
        return /*#__PURE__*/ _jsx("a", {
            href: href,
            onClick: onClick,
            className: classNames,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx("button", {
        onClick: onClick,
        className: classNames,
        children: children
    });
};
